import React from "react"
import * as s from './css/prevendita-chiusa.module.css'
import alert from '../../../../images/alert_empty.png'

const PrevenditaChiusa = ({ project }) => {

    const titolo = {
        soldout: `La prevendita della Carta Hit di ${project.__influencerName} è chiusa.`,
        close: 'La prevendita è chiusa.'
    };
    const testo = {
        soldout: null,
        close: 'Resta in contatto con Tinaba e seguici sui nostri social per non perdere i prossimi appuntamenti!',
    }

    return (
        <div className={`container-grid ${s.container}`}>
            <div className={`col-span-4 desktop:col-span-6 desktop:col-start-4 shadow-1 ${s.content}`}>
                <img src={alert} style={{width:'25px'}} alt="attenzione: prevendita chiusa" />
                <div className="text-6 text-black font-md leading-6_1" style={{marginTop:'17px'}}>{titolo[project.status]}</div>
                {testo[project.status] !== null && <div className="text-8 leading-5 text-black font-rg" style={{marginTop:'6px'}}>{testo[project.status]}</div>}
            </div>
        </div>
    )
}

export default PrevenditaChiusa